import type { Theme } from '@mui/material/styles';

//
import { InputSelectIcon } from './CustomIcons';

const Select = (theme: Theme) => {
  return {
    MuiSelect: {
      defaultProps: {
        IconComponent: InputSelectIcon,
      },
    },
  };
};

export default Select;
